import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './zh-CN';
import zhHK from './zh-HK';
import en from './en';

Vue.use(VueI18n);

// 支持的语言列表
export const supportedLocales = ['zh-CN', 'zh-HK', 'en'];

// 默认语言
export const defaultLocale = 'zh-CN';

// 从 localStorage 获取保存的语言，如果没有则使用默认语言
const getSavedLocale = () => {
	try {
		const saved = localStorage.getItem('locale');
		return saved && supportedLocales.includes(saved) ? saved : defaultLocale;
	} catch (e) {
		return defaultLocale;
	}
};

// 创建 i18n 实例
const i18n = new VueI18n({
	locale: getSavedLocale(),
	fallbackLocale: defaultLocale,
	messages: {
		'zh-CN': zhCN,
		'zh-HK': zhHK,
		en: en
	},
	silentTranslationWarn: true
});

// 切换语言
export const setLocale = locale => {
	if (!supportedLocales.includes(locale)) {
		console.warn(`Unsupported locale: ${locale}, falling back to ${defaultLocale}`);
		locale = defaultLocale;
	}
	i18n.locale = locale;
	localStorage.setItem('locale', locale);
};

export default i18n;
